<template>
  <div class="skeleton-wrapper">
    <div class="body">
      <div class="body-l">
        <div class="circle" />
        <div class="rect" />
      </div>
      <div class="body-r">
        <div class="row-1">
          <div class="row-1-1" />
          <div class="row-1-2" />
        </div>
        <div class="row-2" />
        <div class="row-3">
          <div class="row-3-1" />
          <div class="row-3-2" />
          <div class="row-3-3" />
          <div class="row-3-4" />
          <div class="row-3-5" />
          <div class="row-3-6" />
          <div class="row-3-7" />
        </div>
        <div class="line" />
        <div class="row-3">
          <div class="row-3-1" />
          <div class="row-3-2" />
          <div class="row-3-3" />
          <div class="row-3-4" />
          <div class="row-3-5" />
          <div class="row-3-6" />
          <div class="row-3-7" />
        </div>
      </div>
    </div>
    <div class="line" />
    <div class="footer">
      <div class="item" />
      <div class="item" />
      <div class="item" />
    </div>
  </div>
</template>

<script setup>

</script>

<style lang='less' scoped>
.skeleton-wrapper {
  height: 322px;
  border: 1px solid #ebf1f5;
  border-radius: 8px;
  padding: 24px 16px;

  @media (min-width: 1280px) {
    padding: 24px;
  }

  .body {
    display: flex;
    gap: 16px;
    .body-l {
      display: flex;
      gap: 12px;

      .circle {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
      }
      .rect {
        width: 80px;
        height: 80px;
        border-radius: 6px;
        animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
      }
    }
    .body-r {
      flex: 1;
      .row-1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        > div {
          animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
        }
        .row-1-1 {
          width: 100%;
          height: 36px;
          border-radius: 4px;
        }
        .row-1-2 {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
      }
      .row-2 {
        width: 160px;
        height: 16px;
        border-radius: 4px;
        margin-top: 8px;
        animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
      }
      .row-3 {
        margin-top: 16px;
        display: flex;
        align-items: center;
        > div {
          animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
        }
        .row-3-1 {
          width: 16px;
          height: 16px;
          border-radius: 50%;
        }
        .row-3-2 {
          width: 40px;
          height: 40px;
          border-radius: 4px;
          margin-left: 10px;
        }
        .row-3-3 {
          width: 166px;
          height: 32px;
          border-radius: 4px;
          margin-left: 12px;

          @media (min-width: 1280px) {
            width: 216px;
          }
        }
        .row-3-4 {
          margin-left: 16px;
          width: 96px;
          height: 32px;
          border-radius: 4px;

          @media (min-width: 1280px) {
            margin-left: 24px;
            width: 108px;
          }
        }
        .row-3-5 {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          margin-left: 16px;
        }
        .row-3-6 {
          width: 84px;
          height: 16px;
          border-radius: 4px;
          margin-left: 24px;

          @media (min-width: 1280px) {
            width: 102px;
          }
        }
        .row-3-7 {
          @media (min-width: 1280px) {
            margin-left: auto;
            width: 102px;
            height: 16px;
            border-radius: 4px;
          }
        }
      }
      .line {
        margin: 16px 0;
        height: 1px;
        background-color: #ebf1f5;
      }
    }
  }
  .line {
    height: 1px;
    background-color: #ebf1f5;
    margin-top: 48px;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: end;
    height: 62px;
    .item {
      width: 154px;
      height: 24px;
      border-radius: 4px;
      margin-left: 24px;
      animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
    }
  }
}

@keyframes skeleton {
  0% {
    background-color: #EBEBEB;
  }
  25% {
    background-color: #F8F8F8;
  }
  80% {
    background-color: #EBEBEB;
  }
  100% {
    background-color: #EBEBEB;
  }
}
</style>
